import { baseUrl } from 'utils/axios'
import { Option, Select } from './Select'
import { useQuery } from '@tanstack/react-query'
import { parseUnits } from 'features/units/unitsMappers'
import { UnitDimension } from 'types/unitsEnums.interface'

export const UnitSelect = ({
  onChange,
  value,
  width,
  label,
  placeholder,
  dimension,
}: {
  onChange: (value: Option) => void
  value?: Option | null
  width?: string
  label?: string
  placeholder?: string
  dimension?: UnitDimension
}) => {
  const { data: units } = useQuery({
    queryKey: ['units', dimension],
    queryFn: async () => {
      const data = await baseUrl.get('/units', {
        params: {
          page: 1,
          limit: 1000,
        },
      })
      return parseUnits(data.data, dimension)
    },
  })
  return (
    <Select
      width={width}
      label={label}
      placeholder={placeholder || 'Select unit'}
      options={units || []}
      onChange={(value) => onChange(value)}
      value={
        value
          ? {
              label: value.label,
              value: value.value,
            }
          : null
      }
    />
  )
}
